import {Injectable} from '@angular/core';
import {Router} from '@angular/router';
import {UserService} from '../../shared/services/user.service';
import {AuthServerProvider} from '../../shared/services/auth-session.service';

@Injectable()
export class LoginService {

    constructor(
        private userService: UserService,
        private authServerProvider: AuthServerProvider,
        private router: Router,
    ) {
    }

    login(credentials) {
        return this.authServerProvider.login(credentials).toPromise();
    }

    logout() {
        this.userService.getAccount(false).then(
            (account) => {
                if (account && account.franceConnectSubscription) {
                   this.fcLogout();
                } else {
                    this.authServerProvider.logout().subscribe(() => {
                        this.userService.clearUserState();
                        this.router.navigate(['authentication']);
                    });
                }
            }
        );
    }

    fcLogout() {
        this.authServerProvider.fcLogout()
            .subscribe(fcLogOutUrl => window.location.href = fcLogOutUrl);
    }
}



// WEBPACK FOOTER //
// ./src/main/webapp/app/account/authentication/login.service.ts